// 翻訳
export async function translationToEn(text) {
  const API_KEY = '0f6d969e-4476-b856-d215-e2a6aeb7d88f:fx';
  const API_URL = 'https://api-free.deepl.com/v2/translate';

  const content = encodeURI(
    'auth_key=' + API_KEY + '&text=' + text + '&source_lang=JA&target_lang=EN'
  );
  const url = API_URL + '?' + content;

  const response = await fetch(url);
  const json = await response.json();
  return json['translations'][0]['text'];
}
